import React from 'react'
import Button from 'react-bootstrap/Button'


class ListItem extends React.Component {

    constructor(props) {
        super(props);
        this.handleResize = this.handleResize.bind(this);
        this.state = {
            windowWidth: 100,
            windowHeight: 100,
            mvflg: false
        };
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(){
        if(this.state.mvflg){
            this.setState({ mvflg: false });
        }else{
            this.setState({ mvflg: true });
        }
    }
    handleResize (e) {
        setTimeout(function() {
            this.setState({windowWidth: window.innerWidth, windowHeight: window.innerHeight });
            
        }.bind(this), this.state.frame);
    }

    componentDidMount () {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        this.setState({ mvflg: false });
    }
    
render () {

    let items = null;

    if(this.state.mvflg){
        items =
        <model-viewer
        key={'mov'+this.props.title}
        src={"./models/"+this.props.glb}
        ios-src={"./models/"+this.props.usdz}
        alt=""
        auto-rotate=''
        camera-controls=''
        autoplay=''
        ar=''
        ar-modes="webxr scene-viewer quick-look"
        ar-scale="auto"
        auto-rotate-delay='0'
        interaction-prompt="none"
        environment-image='./models/226374615.hdr'
        skybox-image='./models/226374615.hdr'
        background-color="#0079c2"
        style={{
            position:'fixed',
            top:'0',
            left:'0',
            zIndex:'9999',
            backgroundColor:"#0079c2",
            width:this.state.windowWidth+'px',
            height:this.state.windowHeight+'px',
        }}
        >
            <button  onClick={this.handleClick} slot="" variant={"outline-light"}
            style={{ borderRadius:'.8em', position: 'fixed', top: '1em', left: '1em', padding: '.5em 1em', backgroundColor: 'unset', color: 'white', border: '1px solid white'}}>
                <span>CLOSE</span>
            </button>
            <button slot="ar-button" variant={"outline-light"}
            style={{ borderRadius:'.8em', position: 'fixed', top: '1em', right: '1em', padding: '.5em 1em', backgroundColor: 'unset', color: 'white', border: '1px solid white'}}>
                <span>AR</span>
            </button>

    </model-viewer>;
    }else{
        items = null;
    }

return (<>
    <Button className={'listitem'} onClick={this.handleClick} variant={"outline-light"}>
        <span>{this.props.title}</span>
    </Button>
    {items}
    </>)

  }
    
}

export default ListItem